__turbopack_context__.v({
  "blockImage": "BlockImage-module-scss-module__U1ZmGa__blockImage",
  "blockImageFlex": "BlockImage-module-scss-module__U1ZmGa__blockImageFlex",
  "embeddedEntry": "BlockImage-module-scss-module__U1ZmGa__embeddedEntry",
  "flushBottom": "BlockImage-module-scss-module__U1ZmGa__flushBottom",
  "flushTop": "BlockImage-module-scss-module__U1ZmGa__flushTop",
  "fullWidth": "BlockImage-module-scss-module__U1ZmGa__fullWidth",
  "image": "BlockImage-module-scss-module__U1ZmGa__image",
  "roundedBottom": "BlockImage-module-scss-module__U1ZmGa__roundedBottom",
  "roundedTop": "BlockImage-module-scss-module__U1ZmGa__roundedTop",
});
